<!--
 * @Author: zyy
 * @Date: 2022-11-21 14:44:36
 * @LastEditors: zyy
 * @LastEditTime: 2022-11-21 16:57:09
 * @Description: default
-->

<template>
    <div class="repair-items app-region blank-t-v blank-l-h blank-r-h">
        <a-card :bordered="false">
            <!-- <a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal">
                <a-col :span="24" :xl="6">
                    <a-row :gutter="[8, 8]">
                        <a-col>
                            <p>商品名称:</p>
                        </a-col>
                        <a-col>
                            <a-input placeholder="请输入订单编号" v-model="searchQuery.name"></a-input>
                        </a-col>
                    </a-row>
                </a-col>
                <a-col :span="24" :xl="6">
                    <a-space>
                        <a-button type="primary" @click="getList">查询</a-button>
                        <a-button @click="searchReset">重置</a-button>
                        <a-button type="primary" @click="searchReset">
                            刷新</a-button>
                    </a-space>
                </a-col>
            </a-row> -->
            <a-spin tip="加载中..." :spinning="table.loading">
                <!-- 表格 -->
                <a-table :columns="columns" :data-source="table.data" rowKey="id" :pagination="ipagination"
                    @change="handlePageChange">
                    <div slot="image" slot-scope="data" style="display: flex;">
                        <dy-image :src="item" :preview="true" v-for="item,index in data.images" :key="index" style="margin-right:5px" ></dy-image>
                    </div>
                    <template slot="status" slot-scope="data">
                        <span>{{data.status === 'show' ? '● 显示':'● 隐藏'}}</span>
                    </template>
                    <template slot="action" slot-scope="data">
                        <a @click="edit(data)">编辑</a>
                        <a-divider type="vertical" />
                        <a @click="del(data)" style="color:#fb8387">删除</a>
                    </template>
                </a-table>
            </a-spin>
        </a-card>
        <CommentInfo @submit="getList" ref="commentInfoRef" />
    </div>
</template>
  
<script>
import CommentService from "@/io/goods/comment.js";
import { TJListMixin } from '@/mixins/list.js'
import CommentInfo from './modules/CommentInfo.vue'

export default {
    name: "dispatchModelList",
    components: {
        CommentInfo
    },
    mixins: [TJListMixin],
    data() {
        return {
            modal: {
                show: false,
                loading: false,
                // 0新增，1编辑
                type: 0,
                integralData: null
            },
            rules: {},

            columns: [
                {
                    title: "评论id",
                    dataIndex: "id",
                },
                {
                    title: "商品名称",
                    customRender: data => data.shoprogoods?.title || ''
                },
                {
                    title: "评论用户",
                    customRender:data=> data.user?.nickname || ''
                },
                {
                    title: "评价星级",
                    dataIndex: "level",
                },
                {
                    title: "评价内容",
                    dataIndex: "content",
                },
                {
                    title: "评价图片",
                    key: "image",
                    scopedSlots: { customRender: 'image' },
                },
                {
                    title: "显示状态",
                    key: "status",
                    scopedSlots: { customRender: 'status' },
                },
                {
                    title: "评论时间",
                    dataIndex: "createtime",
                },
                {
                    title: "更新时间",
                    dataIndex: "updatetime",
                },
                {
                    title: "操作",
                    key:'action',
                    scopedSlots: { customRender: "action" },
                },
            ],
            table: {
                loading: false,
                data: [],
            },

        };
    },
    methods: {
        getList() {
            this.table.loading = true;
            const { current, pageSize } = this.ipagination;
            CommentService.list({
                page: current,
                limit: pageSize,
                ...this.searchQuery
            }).then(res => {
                this.table.data = res.data.rows;
                this.ipagination.total = res.data.total;
                this.table.loading = false;
            })

        },
        edit(data){
            this.$refs.commentInfoRef.open(data)
        },

        submit() {
            this.modal.show = false
            this.getList()
        },
        // 删除分类
        del({ id }) {
            this.$confirm({
                title: '提示',
                content: '确定要删除该评价吗？',
                onOk: () => {
                    CommentService.del(id).then(res => {
                        if (res.code === 1) {
                            this.$message.success(res.msg)
                            this.getList()
                        } else {
                            this.$message.error(res.msg)
                        }
                    })
                }
            })

        },


    },
};
</script>
<style scoped lang="less">
.text-center {
    text-align: center;
}

.table-title {
    background-color: #e8e8e8;
    padding: 0 20px;
}
</style>
  